import React from 'react'
import { cn } from '@/utils'

type LiveAreaProps = {
  left: number
  top: number
  width: number
  height: number
  background?: string
  opacity?: number
  className?: string
}

const LiveArea: React.FC<LiveAreaProps> = ({
  left,
  top,
  width,
  height,
  background = 'transparent',
  opacity = 1,
  className,
}) => {
  return (
    <div
      className={cn('absolute pointer-events-none', className)}
      style={{
        left,
        top,
        width,
        height,
        background,
        opacity,
      }}
    />
  )
}

export default LiveArea
